import jaLocale from 'element-ui/lib/locale/lang/ja'
const ja = {
  message: {
    'toLogin': 'アカウント登録',
    'login': 'ログイン',
    'userName': 'ユーザー名',
    'enterprise': 'エンタープライズ',
    'mobilePhone': '携帯電話番号',
    'ObtAccount': 'Obtアカウント',
    'password': 'パスワード',
    'verificationCode': '検証コード',
    'home': '最初のページ',
    'ItineraryBooking': 'スケジュール',
    'myApplication': '私の申請',
    'myApproval': '私の承認',
    'myOrder': '私の注文',
    'myItinerary': '私のスケジュール',
    'dataManagement': 'データ管理',
    'airTickets': '国内航空券',
    'International': '国際航空券',
    'hotel': 'ホテルの予約',
    'trainTickets': '汽車の切符',
    'notBooking': '予約不可',
    'pleaseEnableTrToBook': 'tr予約権限を開いてください',
    'cannotBeBooked': '承認されていないストリームのデータは,予約不可能である',
    'certificateInformation': '証明書の情報を守ってください'
  },
  'AuthenticationFailure': '身元認証の失効',
  '00000': '未知の誤り!',
  '00001': '保存に失敗!',
  '00002': '保存に成功する!',
  '00003': '削除に成功！',
  '00004': '削除に失敗！',
  '10001': 'ユーザー名が衝突する場合は、企業番号を入力してください!',
  // 改签新增字段（占位，待翻译）
  R214: '改签类型',
  R215: '改签原因',
  R216: '自愿改期',
  R217: '非自愿改期',
  R218: '请选择改签原因',
  R219: '已提交人工处理，请等待客服确认',
  R220: '提交人工处理',
  R221: '非自愿改签仅支持同舱位航班',
  ...jaLocale
}

export default ja



// WEBPACK FOOTER //
// ./src/i18n/langs/japanese.js